import { render, staticRenderFns } from "./attrConfig.vue?vue&type=template&id=9d287282&scoped=true"
import script from "./attrConfig.vue?vue&type=script&lang=js"
export * from "./attrConfig.vue?vue&type=script&lang=js"
import style0 from "./attrConfig.vue?vue&type=style&index=0&id=9d287282&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d287282",
  null
  
)

export default component.exports